import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Badge from 'material-ui/Badge';
import AlertWarning from 'material-ui/svg-icons/alert/warning';
import {grey200, grey400, red500} from 'material-ui/styles/colors';
import CodeMirror from 'react-codemirror2';
import 'codemirror/mode/javascript/javascript';
import widgetTypes from '../../components/widgetTypes';
import QuestionPicker from '../../components/QuestionPicker';

const styles = {
  nameInput: {
    width: 500,
  },
  typeSelectField: {
    width: 300,
  },
  configLabel: {
    color: grey400,
    display: 'block',
    fontSize: '16px',
    lineHeight: '22px',
    margin: '40px 0 10px',
  },
  configWrapper: {
    border: '1px solid' + grey200,
    borderRadius: '2px',
  },
  invalidJSONLabel: {
    color: red500,
    float: 'right',
    display: 'inline-block',
    marginTop: '-24px',
  },
};

function getStateFromProps(props) {
  const configObject = props.widget.config || {question: ''};
  return {
    name: props.widget.name || '',
    type: props.widget.type || 'distribution',
    configString: JSON.stringify(configObject, null, 2),
    configObject: configObject,
    configValidJSON: true,
  };
}

class WidgetForm extends Component {
  constructor(props) {
    super(props);
    this.state = getStateFromProps(props);
  }

  updateName = (event, value) => {
    this.setState({name: value});
  };

  updateType = (event, index, value) => {
    this.setState({type: value});
  };

  updateQuestion = (questionMongoId) => {
    const newConfigObject = Object.assign({}, this.state.configObject, {question: questionMongoId});
    this.setState({
      configObject: newConfigObject,
      configString: JSON.stringify(newConfigObject, null, 2),
    });
  };

  updateConfig = (editor, metadata, configString) => {
    this.setState({configString: configString});
    let configObject = {};
    try {
      configObject = JSON.parse(configString);
    } catch(err) {
      this.setState({configValidJSON: false});
      return;
    }
    this.setState({configValidJSON: true});
    this.setState({configObject: configObject});
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.name !== this.state.name ||
      prevState.type !== this.state.type ||
      prevState.configObject !== this.state.configObject ||
      prevState.configValidJSON !== this.state.configValidJSON
    ) {
      this.props.onChange(
        {
          name: this.state.name,
          type: this.state.type,
          config: this.state.configObject,
        },
        this.state.configValidJSON,
      );
    }

    if (
      prevProps.widget.name !== this.props.widget.name ||
      prevProps.widget.type !== this.props.widget.type ||
      prevProps.widget.config !== this.props.widget.config
    ) {
      this.setState(getStateFromProps(this.props));
    }
  }

  render() {
    return (
      <div>
        <TextField
          floatingLabelText="Widget Name (optional)"
          value={this.state.name}
          onChange={this.updateName}
          style={styles.nameInput}
        />
        <br />
        <SelectField
          floatingLabelText="Widget Type"
          value={this.state.type}
          onChange={this.updateType}
          style={styles.typeSelectField}
        >
          {widgetTypes.map(widgetType => 
            <MenuItem key={widgetType.id} value={widgetType.id} primaryText={widgetType.name} />
          )}
        </SelectField>
        <br />
        <QuestionPicker
          selectedQuestion={this.state.configObject.question}
          surveys={this.props.surveys}
          onChange={this.updateQuestion}
          wrapperStyles={{marginTop: 20}}
        />
        <label style={styles.configLabel}>
          Config JSON
          {this.state.configValidJSON ?
            null
            :
            <Badge
              badgeContent={<AlertWarning color={red500} />}
              style={styles.invalidJSONLabel}
            >
              Invalid JSON
            </Badge>
          }
        </label>
        <div style={styles.configWrapper}>
          <CodeMirror
            value={this.state.configString}
            onChange={this.updateConfig}
            options={{
              mode: {
                name: 'javascript', 
                json: true,
              },
              lineNumbers: true,
            }}
          />
        </div>
      </div>
    );
  }
}

export default createFragmentContainer(
  WidgetForm,
  graphql`
    fragment WidgetForm_surveys on SurveyConnection {
      ...QuestionPicker_surveys
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/WidgetForm/WidgetForm.js